import Vue from "vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import Vuetify from "vuetify";

import VueExcelXlsx from "vue-excel-xlsx";

import $ from "jquery";
window.$ = $;
window.jQuery = $;

import EmailConversa from "./components/vue/email/EmailConversa.vue";
import ModalResposta from "./components/vue/email/ModalResposta.vue";
import ConfigElocaErp from "./components/vue/config-eloca-erp/ConfigElocaErp.vue";
import RelatorioProdutividade from "./components/vue/Reletorios/RelatorioProdutividade.vue";
import BotNotificacoes from "./components/vue/Reletorios/BotNotificacoes.vue";
import VuetifyWrapper from "./components/vue/VuetifyWrapper.vue";
import TreinamentoIA from "./components/vue/ia/TreinamentoIA.vue";
import RelatoriosIA from "./components/vue/ia/RelatoriosIA.vue";
import SimpleChart from "./components/vue/ui/SimpleChart.vue";

Vue.config.productionTip = false;

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("email-conversa", EmailConversa);
Vue.component("email-resposta", ModalResposta);
Vue.component("config-eloca-erp", ConfigElocaErp);
Vue.component("relatorio-produtividade", RelatorioProdutividade);
Vue.component("bot-notificacoes", BotNotificacoes);
Vue.component("vuetify-wrapper", VuetifyWrapper);
Vue.component("treinamento-ia", TreinamentoIA);
Vue.component("relatorios-ia", RelatoriosIA);
Vue.component("simple-chart", SimpleChart);

Vue.use(CKEditor);
Vue.use(Vuetify);
Vue.use(VueExcelXlsx);

const app = new Vue({
    delimiters: ["[[", "]]"],
    vuetify: new Vuetify(),
}).$mount("#app");
